import { Stack, Text } from '@chakra-ui/react'
import type { ReactElement } from 'react'

import UserQ from '@/queries/UserQ'
import type { Query } from '@/client/query'
import { getUserUrl } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'
import UserAvatar from '@/components/UserAvatar'

export default function CohostReviewTableAvatar({ user }: { user: Query }): ReactElement {
  const userId = user(UserQ.id) ?? 0
  const userName = user(UserQ.display_name) ?? ''
  const avatarUrl = user(UserQ.avatar_url)
  const cohostProgressionLevel = user(UserQ.progression_level)
  const username = user(UserQ.username)

  return (
    <ShwLink href={getUserUrl({ userId, username })}>
      <Stack
        direction="row"
        align="center"
        p="8px"
        borderRadius="8px"
        _hover={{ backgroundColor: 'bg.muted' }}
        cursor="pointer"
      >
        <UserAvatar
          src={`${avatarUrl}`}
          size="md"
          name={userName}
          progressionLevel={cohostProgressionLevel}
        />
        <Text fontWeight="bold">{userName}</Text>
      </Stack>
    </ShwLink>
  )
}
